import { reservesConfig } from '../../../../config';
import { Pagination } from '../../../../../models/Pagination';
import { http } from '../../../../api/axios';
import { ReserveActionValue } from '../../constants';
import { ProductFilter } from '../../../../store/api';

export type FilterAcceptRejectOptions = {
    action: ReserveActionValue;
    pagination: Pagination;
    filters: ProductFilter;
};

export function includeOrExcludeFilter(reserveListId: string, options: FilterAcceptRejectOptions) {
    const { action, filters, pagination } = options;

    return http
        .put(reservesConfig().endpointReserveBulkAcceptReject, filters, {
            params: { ...pagination },
            pathParams: { kind: 'products', reserveListId, action }
        })
        .then(response => response.data);
}
